import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerGet = {
    path: "/template/content-blocker",
    method: ERouteHttpVerb.GET
};
export { routeLocationContentBlockerGet };
